import { RiPuzzleFill } from '@remixicon/react';
import { DecisionGuide } from '@internal/backstage-plugin-hm-react';
import { Container } from '@backstage/ui';

export const ContributeLandingPageIcon = <RiPuzzleFill />;

export const ContributeLandingPage = () => {
  return (
    <Container>
      <DecisionGuide />
    </Container>
  );
};
